export default __webpack_public_path__ + "static/1-deeaebed7ea7967a7b53b1b9dd1575d0.webp";